/**
 * src/utils/undoRedo/commands/BaseCommand.js
 * BaseCommand.js
 * Temel Command sınıfı - Tüm undo-redo komutları bu sınıftan türetilir
 */

class BaseCommand {
  /**
   * @param {string} type - Komut tipi (örn: 'ADD_BOX', 'DELETE_PANEL')
   * @param {object} data - Komut verisi
   * @param {object} sceneData - Three.js sahne verisi (UUID, position, vs.)
   */
  constructor(type, data, sceneData = null) {
    this.type = type;
    this.timestamp = Date.now();
    this.data = {
      before: data.before || null,
      after: data.after || null
    };
    this.sceneData = sceneData;
  }

  /**
   * Komutu çalıştır (redo)
   * Alt sınıflar bu metodu override etmeli
   * @param {object} scene - Three.js scene
   * @param {object} dispatch - Redux dispatch
   */
  execute(scene, dispatch) {
    throw new Error('execute() metodu alt sınıfta implement edilmeli');
  }

  /**
   * Komutu geri al (undo)
   * Alt sınıflar bu metodu override etmeli
   * @param {object} scene - Three.js scene
   * @param {object} dispatch - Redux dispatch
   */
  undo(scene, dispatch) {
    throw new Error('undo() metodu alt sınıfta implement edilmeli');
  }

  /**
   * Komut bilgisini döndür
   * @returns {object}
   */
  toJSON() {
    return {
      type: this.type,
      timestamp: this.timestamp,
      data: this.data,
      sceneData: this.sceneData
    };
  }

  /**
   * JSON'dan komut oluştur
   * @param {object} json
   * @returns {BaseCommand}
   */
  static fromJSON(json) {
    return new BaseCommand(json.type, json.data, json.sceneData);
  }
}

export default BaseCommand;
